import React from 'react'
import { Button } from 'primereact/button'
import { ConfirmDialog } from 'primereact/confirmdialog'
import { useTranslation } from 'react-i18next'
import './style/cancel_application_confirm_dialog.css'

function CancelApplicationConfirmDialog({ visible, loading, onAccept, onHide }) {
	const { t } = useTranslation()

	return (
		<ConfirmDialog
			visible={visible}
			onHide={onHide}
			header={t('onboarding.common.actions.cancel')}
			message={t('onboarding.common.confirmReject')}
			headerClassName='border-bottom black bg-image'
			className='cancel-application-confirm-dialog'
			draggable={false}
			footer={(
				<div className='cancel-application-confirm-actions'>
					<Button
						type='button'
						label={t('onboarding.common.actions.confirm')}
						onClick={onAccept}
						loading={loading}
						disabled={loading}
						className='bg-green-btn border-0'
					/>
					<Button
						type='button'
						label={t('onboarding.common.actions.no')}
						onClick={onHide}
						disabled={loading}
						className='bg-orange border-0'
					/>
				</div>
			)}
		/>
	)
}

export default CancelApplicationConfirmDialog
